import React, { useState, useEffect } from "react";
import { getInitialsOfUserName } from "../../utils/global";

const MerchantLogoHeader = ({ user_image, shop_name }) => {
  const validImage = user_image !== '' && user_image !== null && user_image !== undefined;

  return (
    <div className="merchant-logo-header-container text-center">
      {validImage &&
        <>
          {shop_name !== 'SuperCheckout' &&
            <>
              <img src={user_image} className="logoImage" alt={shop_name} title={shop_name} />
            </>
          }
        </>
      }
      <div className="merchantNameInitialsContainer mt-2">
        <div className="merchantNameInitials">
          {shop_name}
        </div>
      </div>
    </div>
  );
};

export default MerchantLogoHeader;